<template>
  <div class="data_brain_wrap">
    <el-row class="card_wrap" type="flex">
      <div
        style="
          display: flex;
          width: 100%;
          height: 100%;
          justify-content: center;
        ">
        <div
          style="
            width: 52%;
            height: 100%;
            background-color: #fff;
            position: relative;
            margin-right: 2vw;
          ">
          <div class="page-content">
            <!-- <div class="fenlei">
              <div
                v-for="(item, index) in articleType"
                :key="index"
                class="fenleilist">
                {{ item.name }}
              </div>
            </div> -->

            <div style="padding: 12px; display: flex; flex-direction: column">
              <a
                v-for="(item, index) in report"
                :key="index"
                style="
                  display: flex;
                  padding: 6px 0;
                  border-bottom: 1px solid #eaeaea;
                  max-height: 8vw;
                  cursor: pointer;
                  color: #111;
                "
                :href="item.attachment"
                :download="item.name">
                <div style="height: 6vw; width: 5vw; margin-right: 2vw">
                  <img
                    src="@/assets/true.jpg"
                    alt=""
                    style="width: 100%; height: 100%" />
                </div>
                <div>
                  <div
                    style="position: relative; margin-bottom: 0.4vw"
                    v-if="item.name">
                    <div style="font-size: 2ch; font-weight: 600">
                      {{ item.name }}
                    </div>
                  </div>
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      margin-bottom: 0.4vw;
                      color: #c1c2c4;
                    ">
                    <div
                      style="font-size: 1.8ch; margin-right: 0.2vw"
                      v-if="item.created_at">
                      {{ item.created_at }}
                    </div>
                    <div
                      style="font-size: 1.8ch; margin-right: 0.2vw"
                      v-if="item.source">
                      {{ item.source }}
                    </div>
                    <div style="font-size: 1.8ch" v-if="item.author">
                      {{ item.author }}
                    </div>
                  </div>
                  <div>
                    <div
                      v-for="(item2, index2) in item.getLabel"
                      :key="index2"
                      style="display: inline-block; margin-right: 0.2vw">
                      <div
                        style="
                          font-size: 1.9ch;
                          color: #3952c5;
                          background-color: #a8d6ff;
                          padding: 0.1vw 0.8vw;
                          border-radius: 2vw;
                          font-weight: 600;
                        ">
                        {{ item2.name }}
                      </div>
                    </div>
                  </div>

                  <!-- <div v-html="content"></div> -->
                </div>
              </a>
            </div>
          </div>
          <div
            style="
              position: absolute;
              bottom: 10px;
              display: flex;
              width: 100%;
              justify-content: center;
            ">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-size="pageSize"
              :total="total"
              layout="total, prev, pager, next, jumper"
              background></el-pagination>
          </div>
        </div>
        <div class="card">
          <div
            style="
              width: 100%;
              height: 3%;
              display: flex;
              align-items: center;
              font-weight: 700;
              color: #111;
              font-size: 2.6ch;
            ">
            热门搜索
          </div>

          <div
            style="
              width: 100%;
              height: 20%;
              display: flex;
              flex-wrap: wrap;
              justify-content: space-between;
            ">
            <div
              style="
                width: 30%;
                height: 30%;
                background-color: #a8d6ff;
                display: flex;
                justify-content: center;
                align-items: center;
                font-weight: 600;
                color: #111;
                font-size: 1.9ch;
                opacity: 0.5;
              "
              v-for="(item, index) in types"
              :key="index">
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>
import {
  getArticle,
  getHyReport,
  getHyTypes,
} from "@/api/user.js";
export default {
  data() {
    return {
      currentPage: 1,
      pageSize: 6, // 每页显示的卡片数量
      cardlist: [],
      // 所有数据
      allData: [],
      articleType: [],
      content: "",
      cid: 0,
      jglist: [{ img: "" }],
      report: [],
      types: [],
      total:0,
    };
  },
  props: {
    receivedData: {
      type: Object,
      default: {},
    },
  },
  computed: {
    isToken() {
        if (localStorage.getItem("token") && localStorage.getItem("token") != 'undefined' && localStorage.getItem("token").trim() != '') {
            return true
        } else {
            false
        }
    },
  },
  created() {
    console.log(this.receivedData);
    if(this.isToken){
      getHyTypes().then((res) => {
        console.log("行业报告类型", res);
        this.types = res.data;
      });
    }
    this.getdata();
  },
  watch: {
    receivedData: {
      handler(curVal, oldVal) {
        console.log("收到新数据:", curVal);
        this.getdata(); // 当收到新数据时重新获取数据
      },
      deep: true,
    },
  },
  methods: {
    getdata() {
      const that = this;
      // getArticle({ cid: that.cid }).then((res) => {
      //   console.log(res);
      //   that.allData = res.data;
      //   that.articleType = res.clist;
      // });
      if(this.isToken){
        let param = {
          page: this.currentPage,
          limit: this.pageSize,
          search: {
              labelId: this.receivedData?.labelId||null,
              query: this.receivedData?.input||''
          }
        }
        getHyReport(param).then((res) => {
          console.log("行业报告", res);
          that.report = res.data;
          this.total = res.count;
        });
      }
    },
    // 处理每页显示条目数变化
    handleSizeChange(newSize) {
      this.pageSize = newSize;
      this.currentPage = 1;
      this.getdata();
    },
    // 处理当前页码变化
    handleCurrentChange(newPage) {
      this.currentPage = newPage;
      this.getdata();
    },
    handleNavigate() {
      this.$router.push("/production/1").catch((v) => {
        console.log(v);
      });
    },
    towzlist(item) {
      this.$router.push({
        path: "/wzdetail",
        query: {
          id: item.id, // 你想要传递的 id
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.data_brain_wrap {
  padding: 0 0 70px 0;
  background: #e8eef2;
  // text-align: center;
  .brain_title {
    color: #203040;
    font-size: 40px;
    font-weight: bold;
    padding: 30px 0;
    @media screen and (max-width: 768px) {
      font-size: 1.5rem;
    }
  }
  .brain_desc {
    color: rgba(32, 48, 64, 0.75);
    font-size: 22px;
    letter-spacing: 4px;
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
      line-height: 40px;
    }
  }

  .card_wrap {
    width: 80%;
    flex-wrap: wrap;
    margin: 0px auto;
    justify-content: space-between;
    height: 1200px;
    border-radius: 8px;
    position: relative;
    @media screen and (max-width: 768px) {
      width: 95%;
    }
    .card {
      width: 30%;
      height: 100%;
      display: flex;
      flex-direction: column;
      background-color: #fff;
      padding: 1%;
      .cardInfo {
        padding: 1vw;
        width: 100%;
        height: 20%;
        background: linear-gradient(to bottom right, #ffffff, #94c0fe);
        display: flex;
        flex-direction: column;
        align-items: center;
        .cardTop {
          display: flex;
          align-items: center;
          margin-bottom: 1vw;
          width: 100%;
        }
        .cardBody {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 1vw;
          width: 100%;
          .fabu {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
        }
        .cardBottom {
          margin-bottom: 1vw;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          width: 100%;
          .cardlist {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 30%;
            margin-bottom: 1vw;
          }
        }
        .loginout {
          width: 60%;
          height: 2vw;
          background-color: #f3f5f4;
          text-align: center;
          line-height: 2vw;
          font-size: 2ch;
          font-weight: 600;
          color: #b0b3b7;
          border-radius: 2%;
        }
      }
      .newslist {
        width: 100%;
        height: 14%;
        overflow-y: scroll;
        -ms-overflow-style: none; /* IE 和 Edge */
        scrollbar-width: none; /* Firefox */
      }
      .scrollable-container::-webkit-scrollbar {
        display: none; /* 隐藏滚动条 */
      }
      .newNews {
        width: 100%;
        height: 88%;
        overflow-y: scroll;
        -ms-overflow-style: none; /* IE 和 Edge */
        scrollbar-width: none; /* Firefox */
      }
      .scrollable-container::-webkit-scrollbar {
        display: none; /* 隐藏滚动条 */
      }
    }
    .page-content {
      width: 100%;
      height: 100%;
      padding: 5px;
      .fenlei {
        width: 100%;
        padding: 20px 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .fenleilist {
          height: 2.5vw;
          width: 6vw;
          text-align: center;
          line-height: 2.5vw;
          background-color: #0d067e;
          color: #fff;
          border-radius: 5px;
          cursor: pointer;
        }
      }
    }
    .ggw {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 10%;
      width: 4%;
      margin-right: 1%;
    }
    .top-left {
      height: 100%;
      width: 20%;
      background-color: #0d067e;
      display: flex;
      flex-direction: column;
      border-radius: 6px;
      .top-left-title {
        width: 100%;
        height: 50px;
        display: flex;
        align-items: center;
        color: #fff;
        padding: 10px 20px;
        font-weight: 700;
        font-size: 16px;
      }
      .top-left-info {
        width: 100%;
        flex: 1;
        border-top-right-radius: 6px;
        border-top-left-radius: 6px;
        background-color: #fff;
        padding: 30px 20px;
        overflow-y: scroll;
        -ms-overflow-style: none; /* IE 和 Edge */
        scrollbar-width: none; /* Firefox */
      }
      .scrollable-container::-webkit-scrollbar {
        display: none; /* 隐藏滚动条 */
      }
    }
    .top-center {
      height: 100%;
      width: 50%;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .el-carousel__item h3 {
        color: #475669;
        font-size: 14px;
        opacity: 0.75;
        line-height: 300px;
        margin: 0;
      }

      .el-carousel__item:nth-child(2n) {
        background-color: #99a9bf;
      }

      .el-carousel__item:nth-child(2n + 1) {
        background-color: #d3dce6;
      }
    }
    .brain_item {
      transition: background-color 1s;
      padding: 30px;
      @media screen and (max-width: 768px) {
        font-size: 0.8rem;
        line-height: 40px;
        border-radius: 10px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-top: 20px;
        &:nth-child(-n + 2) {
          margin-top: 0;
        }
      }
      background: #fff;
      border-radius: 20px;
      box-shadow: 0 0.5rem 1.5rem 0 rgba(0, 135, 168, 0.15);
      margin-top: 40px;
      position: relative;
      .item_bg {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(
          134deg,
          #0649b8 1%,
          #0a7fd7 41%,
          #03d2c5 99%
        );
        opacity: 0;
        transition: all 0.5s;
        border-radius: 20px;
        z-index: 1;
      }
      &:hover .item_bg {
        opacity: 1;
      }
      &:hover .item_title {
        color: #fff;
      }
      &:hover .item_desc {
        color: #fff;
      }
      .item_title {
        transition: all 0.5s;
        font-size: 30px;
        font-weight: bold;
        color: #203040;
        text-align: left;
        padding: 20px 0 40px 0;
        z-index: 2;
        position: inherit;
        @media screen and (max-width: 768px) {
          font-size: 1rem;
          text-align: center;
        }
      }
      .item_desc {
        transition: all 0.5s;
        color: #666;
        text-align: left;
        line-height: 1.5rem;
        z-index: 2;
        position: inherit;
        font-size: 18px;
        min-height: 110px;
        @media screen and (max-width: 768px) {
          min-height: 110px;
          text-indent: 2em;
          font-size: 12px;
        }
      }
      .item_navigate {
        width: 100px;
        height: 30px;
        padding: 0 10px;
        background: #ffa400;
        color: #fff;
        border-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        margin-top: 40px;
        cursor: pointer;
        z-index: 2;
        position: inherit;
        @media screen and (max-width: 768px) {
          margin-bottom: 10px;
          font-size: 14px;
        }
      }
    }
  }
}
</style>
